module.exports = __webpack_public_path__ + "img/menu_icon_user_schedule_off.878b005.svg";